export const withUpdatedPatient = (navigationState, patient) => ({
  ...(navigationState || {}),
  params: {
    ...(navigationState?.params || {}),
    patient,
  },
});

export const applySavedPatient = ({ patient, location, navigate, setPatient, setEditedPatient }) => {
  setEditedPatient(patient);
  setPatient(patient);
  navigate(`${location.pathname}${location.search}${location.hash}`, {
    replace: true,
    state: withUpdatedPatient(location.state, patient),
  });
};
